import config from '../../config/config';
import { createQueryParams } from '@nexio/emvio-util-app';
import { buildTableSuccessActionBasedOnCount } from '../../utils/actionCreators';

export const ADJUSTMENTS_LOAD = 'ADJUSTMENTS/ADJUSTMENTS_LOAD';
export const ADJUSTMENTS_SUCCESS = 'ADJUSTMENTS/ADJUSTMENTS_SUCCESS';
export const ADJUSTMENTS_FAILURE = 'ADJUSTMENTS/ADJUSTMENTS_FAILURE';

export const fetchUrl = `${config.reportApiUrl}/adjustments`;

export function getAdjustments(filters, page, pageSize, sorters, merchantIds) {
    const queryParamsString = createQueryParams({
        dateKey: 'reportDate',
        filters,
        merchantIds,
        page,
        pageSize,
        sorters
    });

    return {
        failureActionTypeOrCreator: getAdjustmentsFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: ADJUSTMENTS_LOAD,
        successActionTypeOrCreator: getAdjustmentsSuccessActionCreator
    };
}

export function getAdjustmentsSuccessActionCreator(results) {
    return buildTableSuccessActionBasedOnCount(results, ADJUSTMENTS_SUCCESS, 'adjustments');
}

export function getAdjustmentsFailureActionCreator(error) {
    return {
        error,
        type: ADJUSTMENTS_FAILURE
    };
}
